import React, { useState } from "react";

// css
import "./Team.css";

// components
import TeamCard from "./TeamCard";

// team bio pages
import ToddRBio from "./bios/ToddRBio";
import ScottRBio from "./bios/ScottRBio";
import EricGBio from "./bios/EricGBio";
import ScottCBio from "./bios/ScottCBio";
import DanielGBio from "./bios/DanielGBio";
import KimberlyABio from "./bios/KimberlyABio";
import KateMBio from "./bios/KateMBio";
import JeffHBio from "./bios/JeffHBio";
import IsiahTBio from "./bios/IsiahTBio";
import ChrisFBio from "./bios/ChrisFBio";
// import BrandonHBio from "./bios/BrandonHBio";
import ErikRBio from "./bios/ErikRBio";
import AdamBBio from "./bios/AdamBBio";
import SimonMBio from "./bios/SimonMBio";
import AndrewSBio from "./bios/AndrewSBio";
import MichaelWBio from "./bios/MichaelWBio";

// team images / assets
// import MaleImg from "../../assets/images/PLACEHOLDER-M.jpg";
// import FemaleImg from "../../assets/images/PLACEHOLDER-W.jpg";
// import ToddRImg from "../../assets/images/StratCap-ToddRowley.jpg";
import ScottRImg from "../../assets/images/ScottRiggs.jpg";
import EricGImg from "../../assets/images/EricGraham.jpg";
// import ScottCImg from "../../assets/images/StratCap-ScottCorkery.jpg";
import DanielGImg from "../../assets/images/DanielGreen.jpg";
import KimberlyAImg from "../../assets/images/KimberlyArth.jpg";
import KateMImg from "../../assets/images/KateMitchell.jpg";
import JeffHImg from "../../assets/images/JeffHersh.jpg";
import IsiahTImg from "../../assets/images/IsiahThomas.jpg";
import ChrisFImg from "../../assets/images/ChrisFlynn.jpg";
// import BrandonHImg from "../../assets/images/BrandonHunt.jpg";
import ErikRImg from "../../assets/images/ErikRostvold.jpg";
import AdamBImg from "../../assets/images/Adam-Baxter.jpg";
import SimonMImg from "../../assets/images/SimonMitchell.jpg";
import AndrewSImg from "../../assets/images/AndrewSelim.jpg";
import MichaelWImg from "../../assets/images/MichaelWeidner.jpg";

const Team = () => {
  const [name, setName] = useState("");

  // bio picker function goes here
  const bioPicker = () => {
    switch (name) {
      case "toddR":
        return <ToddRBio closeBio={() => setName("")} />;
      case "scottR":
        return <ScottRBio closeBio={() => setName("")} />;
      case "ericG":
        return <EricGBio closeBio={() => setName("")} />;
      case "scottC":
        return <ScottCBio closeBio={() => setName("")} />;
      case "danielG":
        return <DanielGBio closeBio={() => setName("")} />;
      case "kimberlyA":
        return <KimberlyABio closeBio={() => setName("")} />;
      case "kateM":
        return <KateMBio closeBio={() => setName("")} />;
      case "jeffH":
        return <JeffHBio closeBio={() => setName("")} />;
      case "isiahT":
        return <IsiahTBio closeBio={() => setName("")} />;
      case "chrisF":
        return <ChrisFBio closeBio={() => setName("")} />;
      // case "brandonH":
      //   return <BrandonHBio closeBio={() => setName("")} />;
      case "erikR":
        return <ErikRBio closeBio={() => setName("")} />;
      case "adamB-exec":
        return (
          <AdamBBio
            title2="President and Secretary"
            closeBio={() => setName("")}
          />
        );
      case "adamB-board":
        return (
          <AdamBBio
            title2="Chairman of the Board"
            closeBio={() => setName("")}
          />
        );
      case "simonM":
        return <SimonMBio closeBio={() => setName("")} />;
      case "andrewS":
        return <AndrewSBio closeBio={() => setName("")} />;
      case "michaelW":
        return <MichaelWBio closeBio={() => setName("")} />;
      default:
        return null;
    }
  };

  return (
    <section id="team-content">
      <div className="main-padding">
        <div className="main-margin">
          <h1 className="sub-header mt-0 mb-10">
            Executive Team of Our Advisor
          </h1>
          <p className="mb-12">
            The officers of StratCap Digital Infrastructure REIT, Inc.’s
            Advisor, StratCap Digital Infrastructure Advisors II, LLC, are
            seasoned individuals highlighted by deep domain experience and
            demonstrated historical success. Together, they bring significant
            expertise in securities, investment banking, mergers and
            acquisitions, financial reporting, acquisitions, dispositions,
            financing and asset management. The team also has more than $35
            billion in digital infrastructure-related transactions.
          </p>
          <div>{bioPicker()}</div>
          <div className="team-grid">
            <TeamCard
              imgSrc={AdamBImg}
              name="Adam Baxter"
              title="President and Secretary"
              shouldHover={true}
              setBioName={() => setName("adamB-exec")}
            />
            {/* <TeamCard
              imgSrc={ScottRImg}
              name="Scott Riggs"
              title="Head of Wireless Investments"
              shouldHover={true}
              setBioName={() => setName("scottR")}
            /> */}
            <TeamCard
              imgSrc={ChrisFImg}
              name="Chris Flynn"
              title="Chief Investment Officer of Data Centers"
              shouldHover={true}
              setBioName={() => setName("chrisF")}
            />
            <TeamCard
              imgSrc={MichaelWImg}
              name="Michael Weidner"
              title="Chief Financial Officer"
              shouldHover={true}
              setBioName={() => setName("michaelW")}
            />
            {/* <TeamCard
              imgSrc={BrandonHImg}
              name="Brandon Hunt"
              title="Chief Operating Officer"
              shouldHover={true}
              setBioName={() => setName("brandonH")}
            /> */}
            <TeamCard
              imgSrc={ErikRImg}
              name="Erik Rostvold"
              title="Chief Risk Officer"
              shouldHover={true}
              setBioName={() => setName("erikR")}
            />
            {/* <TeamCard
              imgSrc={EricGImg}
              name="Eric Graham"
              title="General Counsel"
              shouldHover={true}
              setBioName={() => setName("ericG")}
            /> */}
          </div>
          <h1 style={{ marginTop: "80px" }} className="sub-header mb-12">
            Board of Directors
          </h1>
          <div className="team-grid">
            <TeamCard
              imgSrc={AdamBImg}
              name="Adam Baxter"
              title="Chairman of the Board"
              shouldHover={true}
              setBioName={() => setName("adamB-board")}
            />
            <TeamCard
              imgSrc={SimonMImg}
              name="Simon Mitchell"
              title="Director"
              shouldHover={true}
              setBioName={() => setName("simonM")}
            />
            <TeamCard
              imgSrc={AndrewSImg}
              name="Andrew Selim"
              title="Director"
              shouldHover={true}
              setBioName={() => setName("andrewS")}
            />
            <TeamCard
              imgSrc={DanielGImg}
              name="Daniel Green"
              title="Independent Director and Chairperson of the Audit Committee"
              shouldHover={true}
              setBioName={() => setName("danielG")}
            />
            <TeamCard
              imgSrc={KimberlyAImg}
              name="Kimberly Arth"
              title="Independent Director"
              shouldHover={true}
              setBioName={() => setName("kimberlyA")}
            />
            <TeamCard
              imgSrc={JeffHImg}
              name="Jeff Hersh"
              title="Independent Director"
              shouldHover={true}
              setBioName={() => setName("jeffH")}
            />
            <TeamCard
              imgSrc={KateMImg}
              name="Kate Mitchell"
              title="Independent Director"
              shouldHover={true}
              setBioName={() => setName("kateM")}
            />
            <TeamCard
              imgSrc={IsiahTImg}
              name="Isiah Thomas"
              title="Independent Director"
              shouldHover={true}
              setBioName={() => setName("isiahT")}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
